import styled from 'styled-components';
import { useRecoilValue, ticketingDataState } from '../../../store';

const MainWrap = styled.div`
  height: 133px;
  background-color: #282828;
  position: relative;

  .bl-minimized-vector {
    width: 0;
    height: 0;
    right: 0;
    top: 0;
    position: absolute;
    border-bottom: 133px solid #ea475c;
    border-left: 241px solid transparent;
  }

  .bl-minimized-title {
    margin: 0;
    height: 100%;
    padding: 0 300px 0 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    //margin-top: 38px;
    //margin-left: 80px;
    font-weight: 400;
    font-size: 40px;
    line-height: 60px;
    color: white;
    position: absolute;
    //max-height: calc(100% - 38px);
    overflow: hidden;

    @media screen and (max-width: 760px) {
      width: 100%;
      text-align: center;
      margin-left: 0;
    }
  }

  @media screen and (max-width: 760px) {
    height: 77px;
    .bl-minimized-title {
      padding: inherit;
      margin: 0;

      text-align: left;
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 33px;
      //margin-top: 20px;
      //padding-left: 24px;
      //max-height: calc(100% - 20px);
    }
    .bl-minimized-vector {
      border-right: 84px solid #ea475c;
      border-bottom: 77px solid transparent;
    }
  }
`;

const TourImageDescriptionMinized = () => {
  const { ticketingGeneral } = useRecoilValue(ticketingDataState);
  return (
    <MainWrap>
      <div className="bl-minimized-vector" />
      <div
        className="bl-minimized-title"
        dangerouslySetInnerHTML={{ __html: ticketingGeneral.title }}
      />
    </MainWrap>
  );
};

export default TourImageDescriptionMinized;
